enum ClaimTypeDeliveryEnum {
  TRANSPORT = 'transport',
  WARRANTY = 'warranty'
}

export default ClaimTypeDeliveryEnum;
